import styled from 'styled-components'

export const Container = styled.div<{containerOverflow?: boolean}>`
  ${(p): string => (p.containerOverflow ? '' : 'overflow: hidden;')}
`
